var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-modal", class: [_vm.visible ? "c-modal--open" : ""] },
    [
      _c("div", { staticClass: "modal__inner" }, [
        _c("div", { staticClass: "modal-close" }, [
          _c("button", {
            staticClass: "c-button-close",
            attrs: { "area-label": "close" },
            on: { click: _vm.close },
          }),
        ]),
        _vm._v(" "),
        _c("h3", { staticClass: "modal__heading" }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal__content" }, [_vm._t("default")], 2),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }